import omit from 'lodash/omit';
import createApiClient from 'src/modules/seek-jobs-api-client';
import { isSearchResultsPath } from '@seek/seek-jobs-seo';

const api = createApiClient();

export const SAVE_JOB_BEGIN = 'SAVE_JOB_BEGIN';
export const SAVE_JOB_SUCCESS = 'SAVE_JOB_SUCCESS';
export const SAVE_JOB_ERROR = 'SAVE_JOB_ERROR';
export const REMOVE_SAVE_JOB_BEGIN = 'REMOVE_SAVE_JOB_BEGIN';
export const REMOVE_SAVE_JOB_SUCCESS = 'REMOVE_SAVE_JOB_SUCCESS';
const REMOVE_SAVE_JOB_ERROR = 'REMOVE_SAVE_JOB_ERROR';
export const SAVED_JOBS_SEARCH_SUCCESS = 'SAVED_JOBS_SEARCH_SUCCESS';
export const SIGNED_OUT_SAVE_JOB = 'SIGNED_OUT_SAVE_JOB';

const initialState = {
  jobs: {}
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case REMOVE_SAVE_JOB_BEGIN:
    case SAVE_JOB_ERROR: {
      const { jobId } = action.payload;
      const jobs = { ...omit(state.jobs, jobId) };

      return {
        ...state,
        jobs
      };
    }

    case SAVE_JOB_BEGIN:
    case REMOVE_SAVE_JOB_ERROR: {
      const { jobId } = action.payload;
      const newJob = { [jobId]: 'saved' };
      const jobs = { ...state.jobs, ...newJob };

      return {
        ...state,
        jobs
      };
    }

    case SAVED_JOBS_SEARCH_SUCCESS: {
      const savedJobs = action.payload;
      const jobs = { ...state.jobs, ...savedJobs };

      return {
        ...state,
        jobs
      };
    }

    default: {
      return state;
    }
  }
}

const defaultApis = {
  saveJob: args => api.candidate.saveJob(args),
  removeSavedJob: args => api.candidate.removeSavedJob(args)
};

export const saveJob = (job, triggeredByIntent = false, apis = defaultApis) => (
  dispatch,
  getState
) => {
  const { tracking: serpTracking, id: jobId } = job;
  const {
    location: { locale, pathname }
  } = getState();

  const isSerp = isSearchResultsPath(pathname);

  dispatch({
    type: SAVE_JOB_BEGIN,
    payload: {
      jobId,
      triggeredByIntent
    },
    meta: { hotjar: `Saved Job${triggeredByIntent ? ' Logged Out' : ''}` }
  });

  return apis
    .saveJob({ locale, jobId, serpTracking, isSerp })
    .then(() =>
      dispatch({
        type: SAVE_JOB_SUCCESS,
        payload: { jobId, job } // trackingProps used for analytics tracking
      })
    )
    .catch(() =>
      dispatch({
        type: SAVE_JOB_ERROR,
        error: true,
        payload: { jobId }
      })
    );
};

export const saveJobAfterSignin = (jobId, getJobFromState) => (
  dispatch,
  getState
) => {
  const job = getJobFromState(getState());

  return saveJob(job, true)(dispatch, getState);
};

export const removeSavedJob = (job, apis = defaultApis) => (
  dispatch,
  getState
) => {
  const { id: jobId, tracking: serpTracking } = job;
  const {
    location: { locale, pathname }
  } = getState();

  const isSerp = isSearchResultsPath(pathname);

  dispatch({
    type: REMOVE_SAVE_JOB_BEGIN,
    payload: { job, jobId },
    meta: { hotjar: 'Saved Job Removed' }
  });

  return apis
    .removeSavedJob({ locale, jobId, serpTracking, isSerp })
    .then(() =>
      dispatch({
        type: REMOVE_SAVE_JOB_SUCCESS,
        payload: { jobId, job } // trackingProps used for analytics tracking
      })
    )
    .catch(() =>
      dispatch({
        type: REMOVE_SAVE_JOB_ERROR,
        error: true,
        payload: { jobId }
      })
    );
};

export const savedJobSearch = id => (dispatch, getState) => {
  const { results } = getState();
  const jobIds = id ? [id] : results.jobIds;

  if (jobIds.length > 0) {
    return api.candidate.searchSavedJobs({ jobIds }).then(result => {
      dispatch({
        type: SAVED_JOBS_SEARCH_SUCCESS,
        payload: result
      });
    });
  }
  return null;
};

export const signedOutSaveJobClicked = () => ({
  type: SIGNED_OUT_SAVE_JOB
});
